import * as SecureStore from 'expo-secure-store';
import { Platform } from 'react-native';
import { getStreamClient } from "@/services/stream/client";
import { router } from "expo-router";
import { registerDeviceToken } from "@/services/universe/client";

const KEYS = {
    passport: "auth.passportToken",
    streamToken: "auth.streamToken",
    streamUserId: "auth.streamUserId",
    userName: "auth.userName",
    userImage: "auth.userImage",
    deviceToken: "auth.deviceToken",
};

const isWeb = Platform.OS === 'web';

async function setItem(key: string, value: string) {
    if (isWeb) {
        localStorage.setItem(key, value);
    } else {
        await SecureStore.setItemAsync(key, value);
    }
}

async function getItem(key: string) {
    if (isWeb) {
        return localStorage.getItem(key);
    } else {
        return await SecureStore.getItemAsync(key);
    }
}

async function deleteItem(key: string) {
    if (isWeb) {
        localStorage.removeItem(key);
    } else {
        await SecureStore.deleteItemAsync(key);
    }
}

export async function savePassportToken(token: string) {
    await setItem(KEYS.passport, token);
}

export async function getPassportToken() {
    return getItem(KEYS.passport);
}

export async function saveStreamAuth(params: { userId: string; token: string }) {
    await setItem(KEYS.streamUserId, params.userId);
    await setItem(KEYS.streamToken, params.token);
}

export async function getStreamAuth() {
    const userId = await getItem(KEYS.streamUserId);
    const token = await getItem(KEYS.streamToken);
    if (!userId || !token) return null;
    return { userId, token };
}

export async function saveUserProfile(name: string, image: string) {
    if (name) await setItem(KEYS.userName, name);
    if (image) await setItem(KEYS.userImage, image);
}

export async function getUserProfile() {
    const name = await getItem(KEYS.userName);
    const image = await getItem(KEYS.userImage);
    return { name, image };
}

export async function saveDeviceToken(token: string) {
    await setItem(KEYS.deviceToken, token);
}

export async function getDeviceToken() {
    return getItem(KEYS.deviceToken);
}

export async function clearAuth() {
    await deleteItem(KEYS.passport);
    await deleteItem(KEYS.streamUserId);
    await deleteItem(KEYS.streamToken);
    await deleteItem(KEYS.userName);
    await deleteItem(KEYS.userImage);
    await deleteItem(KEYS.deviceToken);
}

export async function logout() {
    try {
        const deviceToken = await getDeviceToken();
        if (deviceToken) {
            await registerDeviceToken(deviceToken, 'inactive');
        }
    } catch (e) {
        console.error("Error unregistering device token:", e);
    }

    try {
        const client = getStreamClient();
        await client.disconnectUser();
    } catch (e) {
        console.error("Error disconnecting user:", e);
    }
    await clearAuth();
    router.replace('/(auth)/login');
}